import { ICardElementWithChildren, ITopElement } from "backend/model/model";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
import useLink from "qpr-base/hooks/useLink";
import { PopoverItem } from "./PopoverItem";
import { getFileApiURL } from "qpr-base/utils/url-utils";
import { getTranslatedAttribute } from "qpr-base/tplutils/utils";
import { useAppContext } from "qpr-base/context/AppCtxProvider";

const useStyles = makeThemedStyles("DepartmentPopover", (theme: any) => ({
  root: {
    background: "#FFFFFF",
    borderRadius: "1.6em",
    padding: "15px 15px 15px 15px",
  },
  items: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "20px",
    padding: "0px 10px 0px 10px",
  },
}));

const PopoverContent = ({
  elements,
  topelements,
  onSelect,
  imageUrl,
}: {
  imageUrl?: string;
  elements: ICardElementWithChildren[];
  topelements: ITopElement[];
  onSelect?: (item: ICardElementWithChildren) => void;
}) => {
  const link = useLink();
  const classes = useStyles();
  const ctx = useAppContext();
  const hasRights = (element: ICardElementWithChildren): boolean =>
    element?.name !== undefined;
  return (
    <div className={classes.root}>
      <div className={classes.items}>
        {elements.map((item) => {
          const topElement = topelements.find(
            (topElement) => topElement.scorecardid === item.id
          );
          return (
            <PopoverItem
              key={item.id}
              departmentIcon={getFileApiURL(`/icons/divisions/DEP_1.svg`)}
              translatedName={getTranslatedAttribute(
                topElement,
                "Name",
                ctx.language
              )}
              pointerStyle={hasRights(item) ? "Pointer" : undefined}
              hasRight={hasRights(item)}
              element={item}
              onSelect={() => {
                hasRights(item)
                  ? link({ page: "strategymap", meaId: item.topelement })
                  : link({});
              }}
              onSelectChild={(elm) => {
                hasRights(item)
                  ? link({ page: "strategymap", meaId: elm.topelement })
                  : link({});
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default PopoverContent;
